import { render, staticRenderFns } from "./addAllClientMsg.vue?vue&type=template&id=0bc6948a&scoped=true&"
import script from "./addAllClientMsg.vue?vue&type=script&lang=js&"
export * from "./addAllClientMsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6948a",
  null
  
)

export default component.exports